export default __webpack_public_path__ + "static/media/alsaadhome.20acb3c7.png";